import { ProFormSelect, ProFormText } from '@ant-design/pro-form';
import { observer } from 'mobx-react-lite';
import React, { FC, Fragment } from 'react';
import { SelectInputFormType } from '@/presentation/components/form/index';
import { useOptions } from '@/presentation/components/form/utils';
import { ExOption, Option } from '@/proto/field';
import styles from './select-input.module.scss';

interface IProps {
  label: string | React.ReactNode;
  leftName: string;
  rightName: string;
  leftOptions: Option[] | ExOption[];
  leftInitialValue?: any;
  rightInitialValue?: string;
  rules?: Record<string, any>[];
}

export const SelectInputGroup: FC<IProps> = props => (
  <Fragment>
    <div className='ant-form-item-label'>
      {props.label}
    </div>
    <div className={styles.selectGroup}>
      <span className={styles.selectLeft}>
        <ProFormSelect
          name={props.leftName}
          options={props.leftOptions}
          initialValue={props.leftInitialValue}
          allowClear={false}
          fieldProps={{
            dropdownClassName: 'reset-font-size',
          }}
        />
      </span>
      <span className={styles.selectRight}>
       <ProFormText
         name={props.rightName}
         rules={props.rules}
         initialValue={props.rightInitialValue}
       />
      </span>
    </div>
  </Fragment>
);

export const SelectInputForm: FC<{
  entry: SelectInputFormType,
  hidden?: boolean,
}> = observer((props) => {
  const { entry, hidden } = props;
  const {
    leftName,
    rightName,
    label,
    leftInitialValue,
    rightInitialValue,
  } = entry;

  if (hidden) {
    return null;
  }

  const options = useOptions({
    fieldKey: entry.fieldKey,
    fieldScope: entry.fieldScope,
    userOptions: undefined,
  });

  return <SelectInputGroup
    label={label}
    leftName={leftName}
    leftOptions={options}
    leftInitialValue={leftInitialValue}
    rightInitialValue={rightInitialValue}
    rightName={rightName}
  />;
});
